/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  Collapse,
  Button,
  Checkbox,
  Col,
  Flex,
  Radio,
  Row,
  Space,
  Select,
  Pagination,
  Spin,
  Tag,
  Input,
} from "antd";
import { filterIcon, filterAquaIcon } from "../assets";
import CandidateLocationsModal from "../components/CandidateLocationsModal";
import CandidateDetails from "./CandidateDetails";
import SVGClose from "../assets/SVGClose";
import "../styles/CandidatePage.css";
import { get, post } from "../lib/Api";
import Toast from "../components/Toast/Toast";
import { ToastContainer } from "react-toastify";
import ConfirmationModal from "../components/modal/ConfirmationModal";
import NoData from "../components/NoData/NoData";
import AppliedCandidateCard from "../components/CandidateCard/AppliedCandidateCard";
const baseUrl = process.env.REACT_APP_BACKEND_URL;

const { Option, OptGroup } = Select;

const AppliedCandidatesPage = () => {
  const inputRef = useRef(null);
  // const { searchData } = location.state || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [visibleDetails, setVisibleDetails] = useState(false);
  const [isDownloadAllModalOpen, setIsDownloadAllModalOpen] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCandidates, setTotalCandidates] = useState(0);
  const [genderCount, setGenderCount] = useState({
    male: 0,
    female: 0,
    other: 0,
  });
  const [pageSize, setPageSize] = useState(10);

  const [searchData, setSearchData] = useState({
    keywords: [],
    currentCity: [],
    minExp: "",
    maxExp: "",
    gender: "",
  });

  const [keywordInputValue, setKeywordInputValue] = useState("");
  const [selectedCandidates, setSelectedCandidates] = useState([]);

  const [selectedCityItems, setSelectedCityItems] = useState(
    searchData?.currentCity || []
  );
  const [selectedStates, setSelectedStates] = useState([]);
  const [statesWithCities, setStatesWithCities] = useState([]);

  const [currentCandidate, setCurrentCandidate] = useState(null);

  const fetchData = async (page) => {
    setLoading(true);
    const data = { ...searchData, page_no: page, page_size: pageSize };
    try {
      const response = await post(
        "job/applied-candidates-list",
        data,
        "",
        true
      );
      if (response?.status === true) {
        setCandidates(response.candidate_applied_jobs_list.results);
        setTotalCandidates(response.count);
        setGenderCount(response.gender);
        setLoading(false);
      } else {
        Toast({ message: response?.message, type: "error" });
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch candidates", error);
      setLoading(false);
    }
  };

  const fetchStatesWithCities = async () => {
    setLoading(true);
    const res = await get(`master/state-wise-city-list`, {}, {}, true);
    if (res?.status === true) {
      setStatesWithCities(res.data);
      setLoading(false);
    } else {
      Toast({ message: res?.message, type: "error" });
      setLoading(false);
    }
  };

  const hasValidSearchData = (data) => {
    return Object.values(data).some((value) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== "";
    });
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, pageSize, searchData]);

  useEffect(() => {
    fetchStatesWithCities();
  }, []);

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const onPageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(current);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    if (id === "minExp" || id === "maxExp") {
      if (/^\d+(\.\d{0,2})?$/.test(value) || value === "") {
        setSearchData({
          ...searchData,
          [id]: value,
        });
      }
    } else {
      setSearchData({
        ...searchData,
        [id]: value,
      });
    }
  };

  const handleGenderTypeChange = (e) => {
    setSearchData({
      ...searchData,
      gender: e.target.value,
    });
  };

  const handleKeyPress = (e) => {
    if (
      (e.key === "Enter" && keywordInputValue.trim() !== "") ||
      (e.key === "Tab" && keywordInputValue.trim() !== "")
    ) {
      const newKeyword = keywordInputValue.trim();
      setSearchData({
        ...searchData,
        keywords: [...searchData.keywords, newKeyword],
      });
      setKeywordInputValue("");
    }
  };

  const handleClickOutside = (event) => {
    if (
      inputRef.current &&
      !inputRef.current.contains(event.target) &&
      keywordInputValue.trim() !== ""
    ) {
      const newKeyword = keywordInputValue.trim();
      setSearchData({
        ...searchData,
        keywords: [...searchData.keywords, newKeyword],
      });
      setKeywordInputValue("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [keywordInputValue]);

  const handleKeywordInputChange = (e) => {
    setKeywordInputValue(e.target.value);
  };

  const handleKeywordRemove = (index) => {
    setSearchData((prevData) => {
      return {
        ...prevData,
        keywords: prevData.keywords.filter((_, i) => i !== index),
      };
    });
  };

  const handleResetData = async () => {
    setSearchData({
      keywords: [],
      currentCity: [],
      minExp: "",
      maxExp: "",
      Gender: "",
    });
  };

  useEffect(() => {
    const newCityToStateMap = {};
    const newStateToCityMap = {};
    statesWithCities.forEach((state) => {
      newStateToCityMap[state.id] = state.cities.map((city) => city.id);
      state.cities.forEach((city) => {
        newCityToStateMap[city.id] = state.id;
      });
    });
  }, [statesWithCities]);

  const handleCityChange = (value) => {
    setSelectedCityItems(value);

    const newlySelectedStates = statesWithCities
      .filter((state) => state.cities.every((city) => value.includes(city.id)))
      .map((state) => state.id);

    setSelectedStates(newlySelectedStates);
    setSearchData({
      ...searchData,
      currentCity: value,
    });
  };

  const handleStateChange = (stateId, stateCities) => {
    const cityIds = stateCities.map((city) => city.id);

    if (selectedStates.includes(stateId)) {
      setSelectedCityItems((prev) =>
        prev.filter((cityId) => !cityIds.includes(cityId))
      );
      setSelectedStates((prev) => prev.filter((id) => id !== stateId));

      setSearchData((prev) => ({
        ...prev,
        currentCity: prev.currentCity.filter(
          (cityId) => !cityIds.includes(cityId)
        ),
      }));
    } else {
      const newCityItems = [...new Set([...selectedCityItems, ...cityIds])];
      setSelectedCityItems(newCityItems);
      setSelectedStates((prev) => [...prev, stateId]);

      setSearchData((prev) => ({
        ...prev,
        currentCity: newCityItems,
      }));
    }
  };

  const getOptions = () => {
    return statesWithCities
      .filter((state) => state.cities.length > 0)
      .map((state) => {
        const allCitiesSelected = state.cities.every((city) =>
          selectedCityItems.includes(city.id)
        );

        return (
          <OptGroup
            key={state.id}
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  checked={allCitiesSelected}
                  onChange={() => handleStateChange(state.id, state.cities)}
                  style={{ marginRight: 8 }}
                />
                {state.name}
              </div>
            }
          >
            {state.cities.map((city) => (
              <Option key={city.id} value={city.id}>
                {city.name}
              </Option>
            ))}
          </OptGroup>
        );
      });
  };

  const filterOption = (input, option) => {
    const state = statesWithCities.find((state) =>
      state.cities.some((city) => city.id === option.value)
    );

    const cityNameMatches = option?.children
      ?.toLowerCase()
      .includes(input.toLowerCase());
    const stateNameMatches = state?.name
      ?.toLowerCase()
      .includes(input.toLowerCase());

    return cityNameMatches || stateNameMatches;
  };

  const handleCandidateSelectChange = (candidateId) => {
    setSelectedCandidates((prevSelected) =>
      prevSelected.includes(candidateId)
        ? prevSelected.filter((id) => id !== candidateId)
        : [...prevSelected, candidateId]
    );
  };

  const handleDownloadAll = async () => {
    if (!hasValidSearchData(searchData)) {
      Toast({
        message: "Please fill in at least one field to download all candidates",
        type: "error",
      });
      return;
    }
    setLoading(true);

    try {
      const res = await post(
        `candidate/download-data-sheet`,
        searchData,
        "",
        true
      );
      if (res?.status === true) {
        // Toast({ message: "Report successfully downloaded", type: "success" });
        const element = document.createElement("a");
        element.href = baseUrl + res.file_path;
        element.download = "";
        element.click();
      } else {
        Toast({
          message: res?.message || "Download failed",
          type: "error",
        });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error downloading file:", error);
      Toast({
        message: error.response?.message || "Download failed",
        type: "error",
      });
      setLoading(false);
      throw error;
    }
  };

  const showFilterModal = () => setIsFilterModalOpen(!isFilterModalOpen);
  const handleOk = () => setIsModalOpen(false);

  const handleVisibleDetails = (candidate) => {
    setCurrentCandidate(candidate);
    setVisibleDetails(true);
  };

  const handleCloseDetails = () => {
    setVisibleDetails(false);
    setCurrentCandidate(null);
  };

  const items = [
    {
      key: "1",
      label: "Must have Keywords",
      children: (
        <div className="checkbox-list chips">
          <Flex
            wrap
            gap="small"
            className="chips-button"
            ref={inputRef}
            // style={{ marginBottom: "10px" }}
          >
            {/* <Button type="primary" ghost icon={<CloseOutlined />}>
              Designer
            </Button>*/}

            <Input
              id="Keywords"
              placeholder="Type Keyword to search"
              value={keywordInputValue}
              onChange={handleKeywordInputChange}
              onKeyDown={handleKeyPress}
            />
            <Space direction="horizontal" className="tags-wrapper">
              {searchData?.keywords?.map((val, index) => (
                <Tag
                  // closeIcon={<SVGClose />}
                  closable
                  onClose={(e) => {
                    e.preventDefault();
                    handleKeywordRemove(index);
                  }}
                  color="success"
                  key={index}
                >
                  {val}
                </Tag>
              ))}
            </Space>
          </Flex>

          {/* <Button type="link" block onClick={showModal}>
            View More
          </Button> */}
        </div>
      ),
    },
    {
      key: "2",
      label: "Current City/Area",
      children: (
        <div className="checkbox-list">
          <Select
            mode="multiple"
            placeholder="Select cities"
            value={selectedCityItems}
            onChange={handleCityChange}
            style={{ width: "100%", height: "auto" }}
            showSearch
            filterOption={filterOption}
          >
            {getOptions()}
          </Select>
        </div>
      ),
    },
    {
      key: "3",
      label: "Gender",
      children: (
        <div className="checkbox-list">
          <Radio.Group
            onChange={handleGenderTypeChange}
            value={searchData.gender}
          >
            <Space direction="vertical">
              <Radio value={"male"}>
                Male <small>({genderCount?.male})</small>
              </Radio>
              <Radio value={"female"}>
                Female <small>({genderCount?.female})</small>
              </Radio>
              <Radio value={"other"}>
                Other <small>({genderCount?.other})</small>
              </Radio>
            </Space>
          </Radio.Group>
        </div>
      ),
    },
    {
      key: "4",
      label: "Experience",
      children: (
        <div className="checkbox-list experience">
          <Row gutter={[16, 16]}>
            <Col xs={12} xl={12}>
              <Input
                id="minExp"
                placeholder={"Min. in years"}
                maxLength={3}
                value={searchData.minExp}
                onChange={handleInputChange}
              />
            </Col>
            <Col xs={12} xl={12}>
              <Input
                id="maxExp"
                placeholder={"Max. in years"}
                maxLength={3}
                value={searchData.maxExp}
                onChange={handleInputChange}
              />
            </Col>
          </Row>
        </div>
      ),
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };

  const handleBlacklistSuccess = (isSuccess) => {
    if (isSuccess) {
      fetchData(currentPage);
    }
  };

  return (
    <>
      <section className="candidate">
        <div className="header">
          <div>
            <div className="header-title">Applied Candidates</div>
            <div className="header-subtitle">
            Review and manage candidates who have applied for jobs.
            </div>
          </div>
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={9} xl={7} className="candidate-mobile">
            <div className="candidate-left">
              <Flex
                className="candidate-filter"
                gap="middle"
                justify="space-between"
                align="center"
              >
                <h3>
                  <img src={filterIcon} alt="" />
                  Filters
                </h3>
                <Button type="link" block onClick={handleResetData}>
                  Clear all
                </Button>
              </Flex>
              <Collapse
                items={items}
                defaultActiveKey={["1"]}
                onChange={onChange}
              />
            </div>
          </Col>
          <Col xs={24} lg={15} xl={17}>
            <div className="candidate-right">
              {loading ? (
                <Spin size="large" />
              ) : candidates?.length > 0 ? (
                candidates?.map((candidate) => (
                  <AppliedCandidateCard
                    key={candidate.id}
                    candidate={candidate}
                    handleVisibleDetails={handleVisibleDetails}
                    isSelected={selectedCandidates.includes(candidate.id)}
                    onSelectChange={() =>
                      handleCandidateSelectChange(candidate.id)
                    }
                  />
                ))
              ) : (
                <NoData message="No Results Found" iconSize={60} />
              )}
              {candidates?.length > 0 && (
                <div className="candidate-right-head">
                  <Pagination
                    current={currentPage}
                    total={totalCandidates}
                    pageSize={pageSize}
                    onChange={onPageChange}
                    onShowSizeChange={onPageSizeChange}
                    showSizeChanger
                    pageSizeOptions={["10", "20", "50", "100", "500"]}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
        <button className="filter-btn btn-visible" onClick={showFilterModal}>
          <img src={filterAquaIcon} alt="" />
        </button>
        <CandidateLocationsModal
          isModalOpen={isModalOpen}
          handleOk={handleOk}
        />
        <CandidateDetails
          visibleDetails={visibleDetails}
          candidate={currentCandidate}
          onClose={handleCloseDetails}
          onBlacklistSuccess={handleBlacklistSuccess}
        />
        <div className="mobile-menu">
          {isFilterModalOpen && (
            <div
              className="candidate-details-overlay"
              onClick={() => setIsFilterModalOpen(false)}
            />
          )}
          <div className={`mobile-menu-modal ${isFilterModalOpen && "active"}`}>
            <button className="close" onClick={showFilterModal}>
              <SVGClose />
            </button>
            <div className="candidate-left">
              <Flex
                className="candidate-filter"
                gap="middle"
                justify="space-between"
                align="center"
              >
                <h3>
                  <img src={filterIcon} alt="" />
                  Filters
                </h3>
                <Button type="link" block onClick={handleResetData}>
                  Clear all
                </Button>
              </Flex>
              <Collapse
                items={items}
                defaultActiveKey={["1"]}
                onChange={onChange}
              />
            </div>
          </div>
        </div>
      </section>
      <ConfirmationModal
        isOpen={isDownloadAllModalOpen}
        onConfirm={() => {
          handleDownloadAll();
        }}
        onCancel={() => setIsDownloadAllModalOpen(false)}
        loading={loading}
        title="Confirm Download"
        message={`Are you sure you want to download ${totalCandidates} profiles? Please note that ${totalCandidates} credits will be deducted from your wallet.`}
      />
      <ToastContainer />
    </>
  );
};

export default AppliedCandidatesPage;
